/**
 * 草图辅助对象状态枚举。
 * 说明：
 * 1. 用于统一表达草图点/草图线是否属于辅助对象；
 * 2. 辅助对象可参与渲染，但默认不应向上层派发点选/线选业务事件；
 * 3. 后续若扩展更多辅助态语义，仅扩展该枚举即可。
 */
export enum SketchAuxiliaryObjectState {
    /** 正式草图对象。 */
    Normal = 'normal',
    /** 辅助草图对象。 */
    Auxiliary = 'auxiliary',
}
